module.exports = __webpack_public_path__ + "img/10979923_L.6318fe56.png";